import React from "react";
import Marquee from "react-fast-marquee";
import { Flex, Text, useColorModeValue } from "@chakra-ui/react";
import useMarqueeList from "../../hook/useMarqueeList";
import useCheckLogin from "../../hook/useCheckLogin";

const MarqueeListMobile = () => {
  const marqueeList = useMarqueeList();

  const { isLogin, isMachineUser, isMachineDomain } = useCheckLogin();

  const bg = useColorModeValue("light.200", "#262D47");
  const color = useColorModeValue("dark.100", "text.100");

  return (
    <Flex px="10px">
      <Marquee className="">
        {marqueeList?.map((item, index) => {
          const { subject, content } = item;
          return (
            <Flex mr="40px" key={`marquee-${index}`}>
              {/* <Text fontSize="sm" fontWeight={`semibold`}>
                {subject}:
              </Text> */}
              <Text
                color="#fff"
                fontWeight={"bold"}
                fontSize={{
                  base: "md",
                  md: "lg",
                }}
              >
                {content}
              </Text>
            </Flex>
          );
        })}
      </Marquee>
    </Flex>
  );
};

export default MarqueeListMobile;
